package com.partejar.app.core.ui.components

import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType

// Keep password keyboard semantics even when the user reveals the text.
internal val passwordKeyboardOptions = KeyboardOptions(
    keyboardType = KeyboardType.Password,
    capitalization = KeyboardCapitalization.None,
    autoCorrectEnabled = false
)
